import React from 'react';
import styled from 'react-emotion';
import { LinePrice } from './ListItemLite';
import { useFauxPricing } from './useFauxPricing';

const ListItemRowWrapper = styled('div')`
  display: flex;
  justify-content: space-between;

  .name {
    color: #000;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 188.188%; /* 22.583px */
  }

  .price,
  .old-price,
  .new-price {
    margin-right: 0 !important;
    margin-left: 8px !important;
    font-size: 12px !important;
    font-family: Roboto !important;
    font-style: normal !important;
    line-height: 188.188% !important; /* 22.583px */
  }

  .old-price {
    font-weight: 400 !important;
  }

  .price,
  .new-price {
    font-weight: 800 !important;
  }

  > div {
    margin: 0 !important;
    display: flex;
    flex-direction: row-reverse;
  }
`;

export const ListItemRow = ({ item }) => {
  const { fauxPrice } = useFauxPricing(item);
  console.log('item', item);
  return (
    <ListItemRowWrapper>
      <p className="name">{item?.name}</p>
      <LinePrice
        data-testid="item-price"
        price={fauxPrice}
        previousPrice={item?.previousPrice}
      />
    </ListItemRowWrapper>
  );
};
